import { useState, useRef, useEffect } from 'react';
import { message, Spin } from 'antd';
import Utils from '@utils/utils'
import ImgComparer from '../imgComparer'
import LightCanvas from './lightCanvas'
import DragAndScale from '../dragAndScale/dragAndScale'
import ToolBoxNew from '../toolBoxNew/toolBoxNew';
import { forwardRef, useImperativeHandle } from 'react'
import { AppContext } from '@utils/AppContext';
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import { IMAGE_TYPE } from '@utils/CONST'
import API from "@api/api";
import styles from './index.module.scss'

const FillLight = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onChange: () => {
            return imgResultRef.current || props.url
        },
        selectPreset,
        lightLoadModule,
        lightSettingChange,
        saveResult
    }))

    const {
        getImgWithWatermark, setInitialized,
        setAdjustLightFlag, saveResultToProject,
        setHighDefult, setAIEditLoading, AIEditLoading,
        setRangeDefult
    } = useContext(AIEditContext)
    const { AIEditTemprojectId, setAIEditTempProjectId, setSelectedTaskListId, setGlobalTaskReadFlag, AIEditRecentTaskId } = useContext(AppContext)

    const isMounted = useRef(true) // 判断组件是否已销毁
    const wrapRef = useRef()
    const dragScaleRef = useRef()
    const lightRef = useRef(null);
    const [orignPicBase64, setOrignPicBase64] = useState()
    const [orignPic, setOrignPic] = useState();
    const [compareBtn, setCompareBtn] = useState(false);
    const [reswidth, setWidth] = useState();
    const [resheight, setHeight] = useState()
    const [displayScale, setDisplayScale] = useState(1)
    const imgWidthRef = useRef()
    const [imgWidth, setImgWidth] = useState() // 图片原始宽度
    const imgHeightRef = useRef()
    const [imgHeight, setImgHeight] = useState() // 图片原始高度
    const [preset, setPreset] = useState()
    const [imgResultWithWatermark, setImgResultWithWatermark] = useState()
    const imgResultRef = useRef()
    const [imgResult, setImgResult] = useState()
    const [reset, setReset] = useState(false)
    const [isInit, setIsInit] = useState(false)
    const [moveFlag, setMoveFlag] = useState(false); // 记录是否是第一次打光
    const [canvasRef, setCanvasRef] = useState(null);
    const [canvasRefMouse, setCanvasRefMouse] = useState(null);
    const [inited, setInited] = useState(false)

    const calcCanvasSize = () => {
        const containerWidth = wrapRef.current?.clientWidth - 120 - 150
        const containerHeight = wrapRef.current?.clientHeight - 45
        const size = Utils.getImgMaxSizeInContainer(
            imgWidthRef.current,
            imgHeightRef.current,
            containerWidth,
            containerHeight
        )
        setDisplayScale(size.width / imgWidthRef.current)
        setWidth(size.width)
        setHeight(size.height)
    }

    useEffect(() => {
        const onWindowResize = (e) => {
            calcCanvasSize()
        }
        window.addEventListener('resize', onWindowResize)
        return () => {
            isMounted.current = false
            window.removeEventListener('resize', onWindowResize)
        }
    }, [])

    useEffect(() => {
        if (props.url) {
            Utils.urlToBase64(props.url).then(base64 => {
                setOrignPic(props.url)
                setOrignPicBase64(base64)
            })
        }
    }, [])

    useEffect(() => {
        if (!orignPic) return
        Utils.getImageDimensions(orignPic).then(({ width, height }) => {
            imgWidthRef.current = width
            setImgWidth(width)
            imgHeightRef.current = height
            setImgHeight(height)
            calcCanvasSize()
            setInited(true)
        })
    }, [orignPic])

    const resetClick = () => {
        setCompareBtn(false)
        imgResultRef.current = null
        setImgResult()
        downloadUrl.current = null
        setPreset()
        setReset(!reset)
        lightRef.current.removeLight()
        dragScaleRef.current.resetCanvas()
        setAdjustLightFlag(true)
        setHighDefult(50)
        setRangeDefult(50)

    }

    const compareClick = () => {
        if (!compareBtn) {
            getImgWithWatermark(imgResult).then(base64 => {
                setImgResultWithWatermark(base64)
                setCompareBtn(true)
            })
        } else {
            setCompareBtn(false)
        }
    }


    const downloadUrl = useRef()
    async function commonDownloadFunc() {
        // 需要登录
        const status = Utils.checkLoginStatus(() => commonDownloadFunc())
        if (!status) return

        if (imgResult) {
            let formdata = new FormData
            formdata.append('file', Utils.convertBase64ToFile(imgResult, 'image.png'))
            const res = await API.uploadImage(formdata)
            if (res.code != 0) throw new Error(res.message)
            const resPath = res.data.filename

            const metaRes = await API.generateMetadatav2({ image: resPath })
            if (!metaRes) return
            Utils.downUrl(metaRes?.data?.[1], 'aiEdit')
        } else if (AIEditRecentTaskId) {
            let res = await API.commonDownload({ taskId: AIEditRecentTaskId })
            if (res?.code != 0) throw new Error(res?.message)
            const image = res.data
            Utils.downUrl(image, 'aiEdit')
            message.success('下载成功');
        }

    }

    const saveResult = async () => {
        const status = Utils.checkLoginStatus(() => saveResult())
        if (!status) return
        if (!imgResult) {
            message.warning('请先执行打光！')
            return
        }
        setAIEditLoading(true)
        const res = await saveResultToProject(props.url, imgResult, AIEditTemprojectId, IMAGE_TYPE.AI_BEAUTY)
        setAIEditLoading(false)
        if (!res) return
        const projectId = res.id
        setSelectedTaskListId(projectId)
        setAIEditTempProjectId(projectId)
        setGlobalTaskReadFlag(pre => !pre)
    }

    const selectPreset = (index, style) => {
        if (!lightRef.current) return
        setPreset(index)
        setCompareBtn(false)
        lightRef.current.removeLight()
        if (style == 'random') {
            lightLoadModule('auto_angle', 1)
            setPreset(0)
        } else {
            if (isInit) {
                lightRef.current.filterLoadModule(style)
            } else {
                lightRef.current.aibeautyInit(initFlag => { // 先取landmarks
                    setIsInit(initFlag)
                    lightRef.current.filterLoadModule(style)
                })
            }
        }
    }

    const lightSettingChange = (val, text) => {
        if (!lightRef.current) return
        lightRef.current.changeLight(val, text)
    }

    const lightLoadModule = (type, value, flag) => { // value为1，type
        if (!lightRef.current) return
        if (isInit) {
            lightLoadModule_child(type, value, flag)
        } else {
            lightRef.current.aibeautyInit(initFlag => { // 先取landmarks
                setIsInit(initFlag)
                lightLoadModule_child(type, value, flag)
            })
        }
    }

    function lightLoadModule_child(type, value, flag) {
        setPreset()
        setCompareBtn(false)
        imgResultRef.current = null
        setImgResult()
        downloadUrl.current = null
        // if(moveFlag) lightRef.current.createLight(50, '#fff') // 当moveFlag为true,不是第一次打光，才重绘光源点
        if (type != 'auto_angle') {
            lightRef.current.resetLight(50, 56, 50);
            setAdjustLightFlag(false)
        }
        lightRef.current.lightLoadModule(56, 50, type, value, value, flag) // 光源初始位置（56, 50）
        setHighDefult(50)
        setRangeDefult(50)
    }

    const getImgResult = (base64) => {
        setReset(false)
        imgResultRef.current = base64
        setImgResult(base64)
        setInitialized(true)
        downloadUrl.current = null
    }

    const getMoveFlag = (val) => {
        setMoveFlag(val)
    }

    const getCanvasRefsFun = (canvasRef, canvasRefMouse) => {
        setCanvasRef(canvasRef)
        setCanvasRefMouse(canvasRefMouse)
    }

    const [moveable, setMoveable] = useState()
    const onDragAndScaleChange = ({ zoom, moveable, zoomable }) => {
        setMoveable(moveable)
    }

    useEffect(() => {
        if (compareBtn) {
            dragScaleRef.current.resetCanvas()
        }

    }, [compareBtn])

    const loadingBox = (
        <div className={styles.loadingBox}>
            <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/loadingBlue.gif" alt="" />
            <p>云端处理中，马上好~</p>
        </div>
    )

    const rightContent = (
        <div className={styles.aiBeautyContent_} style={{ position: 'relative' }} ref={wrapRef}>
            {
                inited ?
                    <div className={styles.aiBeautyContent_Item}>
                        <div className={styles.aiBeautyContent_Scale}>
                            {
                                canvasRefMouse ? <DragAndScale
                                    ref={dragScaleRef}
                                    min={1}
                                    max={8}
                                    onChange={onDragAndScaleChange}
                                    canvasList={[canvasRefMouse, canvasRef]}
                                    disabled={compareBtn ? true : false}
                                    options={[
                                        { label: '适应屏幕', value: 1 },
                                        { label: '100%', value: 1 },
                                        { label: '200%', value: 2 },
                                        { label: '300%', value: 3 },
                                        { label: '400%', value: 4 },
                                    ]}
                                /> : null
                            }
                        </div>
                        {
                            compareBtn ?
                                <div
                                    style={{ height: resheight, width: reswidth, zIndex: 9999 }}>
                                    <ImgComparer
                                        leftImage={orignPic}
                                        rightImage={imgResultWithWatermark}
                                    ></ImgComparer>
                                </div> : null
                        }
                        <LightCanvas
                            opacity={compareBtn ? 0 : 1}
                            reset={reset}
                            ref={lightRef}
                            orignPicBase64={orignPicBase64}
                            orignPic={orignPic}
                            reswidth={reswidth}
                            resheight={resheight}
                            displayScale={displayScale}
                            getImgResult={getImgResult}
                            getMoveFlag={getMoveFlag}
                            getCanvasRefsFun={getCanvasRefsFun}
                            moveable={moveable}
                            errorCallback={props.errorCallback}
                            handleCleanClick={props.handleCleanClick}
                        />
                    </div> : loadingBox
            }
            {
                AIEditLoading && loadingBox
            }
        </div>
    )

    return (
        <div className={styles.aiBeauty}>
            {
                inited &&
                <ToolBoxNew
                    showCompare={compareBtn}
                    compare={{ disabled: !imgResult, trigger: compareClick }}
                    reset={{ disabled: !imgResult, trigger: resetClick }}
                    download={{ disabled: !imgResult && !AIEditRecentTaskId, trigger: commonDownloadFunc }}
                    uploadCb={props.uploadCb}
                />
            }

            <div
                className={styles.aiBeautyContent}
                style={{ borderRadius: inited ? '0 0 16px 16px' : '16px' }}
            >
                {
                    !props.url ?
                        props.defaultPage :
                        rightContent
                }
            </div>
        </div>
    )
})

export default FillLight;
